import { render, staticRenderFns } from "./liste-consommable.html?vue&type=template&id=06abb7b7&scoped=true&external"
import script from "./liste-consommable.js?vue&type=script&lang=js&external"
export * from "./liste-consommable.js?vue&type=script&lang=js&external"
import style0 from "./liste-consommable.scss?vue&type=style&index=0&id=06abb7b7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06abb7b7",
  null
  
)

export default component.exports